const backlog = {
  data: {
    discrepancy: {
      name: 'Discrepancy',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 8,
        },
        'cathleen.solario@adops.com': {
          weight: 9,
        },
        'chris.trammel@adops.com': {
          weight: 3,
        },
        'clara.russell@adops.com': {
          weight: 8,
        },
        'darcie.decaprio@adops.com': {
          weight: 9,
        },
        'heather.casterline@adops.com': {
          weight: 9,
        },
        'jen.hill@adops.com': {
          weight: 9,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 6,
        },
        'maxwell.dickey@adops.com': {
          weight: 7,
        },
        'megan.ahearn@adops.com': {
          weight: 9,
        },
        'michael.edwards@adops.com': {
          weight: 0,
        },
        'michelle.signet@adops.com': {
          weight: 6,
        },
        'michelle.tom@adops.com': {
          weight: 9,
        },
        'misti.schindele@adops.com': {
          weight: 8,
        },
        'sara.steichen@adops.com': {
          weight: 6,
        },
        'travis.ayer@adops.com': {
          weight: 8,
        },
      },
    },
    organization: {
      name: 'Organization',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 0,
        },
        'cathleen.solario@adops.com': {
          weight: 8,
        },
        'chris.trammel@adops.com': {
          weight: 8,
        },
        'clara.russell@adops.com': {
          weight: 9,
        },
        'darcie.decaprio@adops.com': {
          weight: 5,
        },
        'heather.casterline@adops.com': {
          weight: 7,
        },
        'jen.hill@adops.com': {
          weight: 7,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 5,
        },
        'maxwell.dickey@adops.com': {
          weight: 5,
        },
        'megan.ahearn@adops.com': {
          weight: 5,
        },
        'michael.edwards@adops.com': {
          weight: 0,
        },
        'michelle.signet@adops.com': {
          weight: 4,
        },
        'michelle.tom@adops.com': {
          weight: 7,
        },
        'misti.schindele@adops.com': {
          weight: 7,
        },
        'sara.steichen@adops.com': {
          weight: 4,
        },
        'travis.ayer@adops.com': {
          weight: 6,
        },
      },
    },
    pacing: {
      name: 'Pacing',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 10,
        },
        'cathleen.solario@adops.com': {
          weight: 10,
        },
        'chris.trammel@adops.com': {
          weight: 9,
        },
        'clara.russell@adops.com': {
          weight: 7,
        },
        'darcie.decaprio@adops.com': {
          weight: 10,
        },
        'heather.casterline@adops.com': {
          weight: 10,
        },
        'jen.hill@adops.com': {
          weight: 10,
        },
        'joanne.hurley@adops.com': {
          weight: 10,
        },
        'katie.obrien@adops.com': {
          weight: 10,
        },
        'maxwell.dickey@adops.com': {
          weight: 10,
        },
        'megan.ahearn@adops.com': {
          weight: 10,
        },
        'michael.edwards@adops.com': {
          weight: 0,
        },
        'michelle.signet@adops.com': {
          weight: 10,
        },
        'michelle.tom@adops.com': {
          weight: 10,
        },
        'misti.schindele@adops.com': {
          weight: 9,
        },
        'sara.steichen@adops.com': {
          weight: 10,
        },
        'travis.ayer@adops.com': {
          weight: 9,
        },
      },
    },
    person: {
      name: 'Person',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 0,
        },
        'cathleen.solario@adops.com': {
          weight: 5,
        },
        'chris.trammel@adops.com': {
          weight: 7,
        },
        'clara.russell@adops.com': {
          weight: 6,
        },
        'darcie.decaprio@adops.com': {
          weight: 4,
        },
        'heather.casterline@adops.com': {
          weight: 6,
        },
        'jen.hill@adops.com': {
          weight: 6,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 4,
        },
        'maxwell.dickey@adops.com': {
          weight: 6,
        },
        'megan.ahearn@adops.com': {
          weight: 4,
        },
        'michael.edwards@adops.com': {
          weight: 0,
        },
        'michelle.signet@adops.com': {
          weight: 5,
        },
        'michelle.tom@adops.com': {
          weight: 6,
        },
        'misti.schindele@adops.com': {
          weight: 6,
        },
        'sara.steichen@adops.com': {
          weight: 5,
        },
        'travis.ayer@adops.com': {
          weight: 4,
        },
      },
    },
    programmatic: {
      name: 'Programmatic',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 9,
        },
        'cathleen.solario@adops.com': {
          weight: 6,
        },
        'chris.trammel@adops.com': {
          weight: 4,
        },
        'clara.russell@adops.com': {
          weight: 3,
        },
        'darcie.decaprio@adops.com': {
          weight: 6,
        },
        'heather.casterline@adops.com': {
          weight: 3,
        },
        'jen.hill@adops.com': {
          weight: 3,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 9,
        },
        'maxwell.dickey@adops.com': {
          weight: 8,
        },
        'megan.ahearn@adops.com': {
          weight: 8,
        },
        'michael.edwards@adops.com': {
          weight: 10,
        },
        'michelle.signet@adops.com': {
          weight: 9,
        },
        'michelle.tom@adops.com': {
          weight: 2,
        },
        'misti.schindele@adops.com': {
          weight: 3,
        },
        'sara.steichen@adops.com': {
          weight: 9,
        },
        'travis.ayer@adops.com': {
          weight: 10,
        },
      },
    },
    project: {
      name: 'Project',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 0,
        },
        'cathleen.solario@adops.com': {
          weight: 4,
        },
        'chris.trammel@adops.com': {
          weight: 2,
        },
        'clara.russell@adops.com': {
          weight: 4,
        },
        'darcie.decaprio@adops.com': {
          weight: 3,
        },
        'heather.casterline@adops.com': {
          weight: 5,
        },
        'jen.hill@adops.com': {
          weight: 5,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 3,
        },
        'maxwell.dickey@adops.com': {
          weight: 3,
        },
        'megan.ahearn@adops.com': {
          weight: 3,
        },
        'michael.edwards@adops.com': {
          weight: 0,
        },
        'michelle.signet@adops.com': {
          weight: 3,
        },
        'michelle.tom@adops.com': {
          weight: 4,
        },
        'misti.schindele@adops.com': {
          weight: 5,
        },
        'sara.steichen@adops.com': {
          weight: 3,
        },
        'travis.ayer@adops.com': {
          weight: 5,
        },
      },
    },
    revenue: {
      name: 'Revenue',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 0,
        },
        'cathleen.solario@adops.com': {
          weight: 3,
        },
        'chris.trammel@adops.com': {
          weight: 6,
        },
        'clara.russell@adops.com': {
          weight: 5,
        },
        'darcie.decaprio@adops.com': {
          weight: 7,
        },
        'heather.casterline@adops.com': {
          weight: 4,
        },
        'jen.hill@adops.com': {
          weight: 4,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 7,
        },
        'maxwell.dickey@adops.com': {
          weight: 4,
        },
        'megan.ahearn@adops.com': {
          weight: 7,
        },
        'michael.edwards@adops.com': {
          weight: 10,
        },
        'michelle.signet@adops.com': {
          weight: 7,
        },
        'michelle.tom@adops.com': {
          weight: 3,
        },
        'misti.schindele@adops.com': {
          weight: 4,
        },
        'sara.steichen@adops.com': {
          weight: 7,
        },
        'travis.ayer@adops.com': {
          weight: 7,
        },
      },
    },
    time: {
      name: 'Time',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 9,
        },
        'cathleen.solario@adops.com': {
          weight: 7,
        },
        'chris.trammel@adops.com': {
          weight: 10,
        },
        'clara.russell@adops.com': {
          weight: 10,
        },
        'darcie.decaprio@adops.com': {
          weight: 8,
        },
        'heather.casterline@adops.com': {
          weight: 3,
        },
        'jen.hill@adops.com': {
          weight: 8,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 8,
        },
        'maxwell.dickey@adops.com': {
          weight: 9,
        },
        'megan.ahearn@adops.com': {
          weight: 6,
        },
        'michael.edwards@adops.com': {
          weight: 10,
        },
        'michelle.signet@adops.com': {
          weight: 8,
        },
        'michelle.tom@adops.com': {
          weight: 8,
        },
        'misti.schindele@adops.com': {
          weight: 10,
        },
        'sara.steichen@adops.com': {
          weight: 8,
        },
        'travis.ayer@adops.com': {
          weight: 3,
        },
      },
    },
  },
  features: {
    omnisearch: {
      name: 'Omnisearch',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 9,
        },
        'cathleen.solario@adops.com': {
          weight: 6,
        },
        'chris.trammel@adops.com': {
          weight: 6,
        },
        'clara.russell@adops.com': {
          weight: 9,
        },
        'darcie.decaprio@adops.com': {
          weight: 7,
          comments: [
            {
              source: 'https://docs.google.com/document/d/1AC2sVVS-cqnecoGTJur6SP-rIxVbbAPzTjyHRsxphM0/edit',
              text: 'I like the search functionality  but don’t feel like it’s the most intuitive or maybe I just don’t use it to its full potential. All I use it for is searching for a clients name.',
            },
          ],
        },
        'heather.casterline@adops.com': {
          weight: 10,
        },
        'jen.hill@adops.com': {
          validate: true,
          weight: 10,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 7,
        },
        'maxwell.dickey@adops.com': {
          weight: 10,
        },
        'megan.ahearn@adops.com': {
          weight: 6,
        },
        'michael.edwards@adops.com': {
          weight: 0,
        },
        'michelle.signet@adops.com': {
          weight: 6,
        },
        'michelle.tom@adops.com': {
          weight: 7,
        },
        'misti.schindele@adops.com': {
          weight: 10,
        },
        'sara.steichen@adops.com': {
          weight: 6,
        },
        'travis.ayer@adops.com': {
          validate: true,
          weight: 9,
        },
      },
    },
    'data-freshness': {
      name: 'Data Freshness Indicators',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 10,
        },
        'cathleen.solario@adops.com': {
          weight: 5,
        },
        'chris.trammel@adops.com': {
          weight: 3,
        },
        'clara.russell@adops.com': {
          weight: 6,
        },
        'darcie.decaprio@adops.com': {
          weight: 8,
        },
        'heather.casterline@adops.com': {
          weight: 9,
        },
        'jen.hill@adops.com': {
          validate: true,
          weight: 9,
        },
        'joanne.hurley@adops.com': {
          weight: 8,
        },
        'katie.obrien@adops.com': {
          weight: 6,
        },
        'maxwell.dickey@adops.com': {
          weight: 9,
        },
        'megan.ahearn@adops.com': {
          weight: 5,
        },
        'michael.edwards@adops.com': {
          weight: 10,
        },
        'michelle.signet@adops.com': {
          weight: 7,
        },
        'michelle.tom@adops.com': {
          weight: 10,
        },
        'misti.schindele@adops.com': {
          weight: 9,
        },
        'sara.steichen@adops.com': {
          weight: 7,
        },
        'travis.ayer@adops.com': {
          validate: true,
          weight: 8,
        },
      },
    },
    export: {
      name: 'Export',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 9,
        },
        'cathleen.solario@adops.com': {
          weight: 9,
        },
        'chris.trammel@adops.com': {
          weight: 8,
        },
        'clara.russell@adops.com': {
          weight: 10,
        },
        'darcie.decaprio@adops.com': {
          weight: 4,
        },
        'heather.casterline@adops.com': {
          weight: 8,
        },
        'jen.hill@adops.com': {
          validate: true,
          weight: 8,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 5,
        },
        'maxwell.dickey@adops.com': {
          weight: 8,
        },
        'megan.ahearn@adops.com': {
          weight: 8,
        },
        'michael.edwards@adops.com': {
          weight: 0,
        },
        'michelle.signet@adops.com': {
          weight: 3,
        },
        'michelle.tom@adops.com': {
          weight: 6,
        },
        'misti.schindele@adops.com': {
          weight: 8,
        },
        'sara.steichen@adops.com': {
          weight: 3,
        },
        'travis.ayer@adops.com': {
          validate: true,
          weight: 7,
        },
      },
    },
    filter: {
      name: 'Filters, Pre-Filters, and Saved Filters',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 10,
        },
        'cathleen.solario@adops.com': {
          weight: 10,
        },
        'chris.trammel@adops.com': {
          weight: 10,
        },
        'clara.russell@adops.com': {
          weight: 8,
        },
        'darcie.decaprio@adops.com': {
          weight: 9,
        },
        'heather.casterline@adops.com': {
          weight: 7,
        },
        'jen.hill@adops.com': {
          validate: true,
          weight: 7,
        },
        'joanne.hurley@adops.com': {
          weight: 10,
        },
        'katie.obrien@adops.com': {
          weight: 9,
        },
        'maxwell.dickey@adops.com': {
          weight: 7,
        },
        'megan.ahearn@adops.com': {
          weight: 10,
        },
        'michael.edwards@adops.com': {
          weight: 10,
        },
        'michelle.signet@adops.com': {
          weight: 10,
        },
        'michelle.tom@adops.com': {
          weight: 9,
        },
        'misti.schindele@adops.com': {
          weight: 7,
        },
        'sara.steichen@adops.com': {
          weight: 10,
        },
        'travis.ayer@adops.com': {
          validate: true,
          weight: 4,
        },
      },
    },
    'release-notes': {
      name: 'Release Notes',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 9,
        },
        'cathleen.solario@adops.com': {
          weight: 3,
        },
        'chris.trammel@adops.com': {
          weight: 4,
        },
        'clara.russell@adops.com': {
          weight: 3,
        },
        'darcie.decaprio@adops.com': {
          weight: 3,
        },
        'heather.casterline@adops.com': {
          weight: 3,
        },
        'jen.hill@adops.com': {
          validate: true,
          weight: 3,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 3,
        },
        'maxwell.dickey@adops.com': {
          weight: 6,
        },
        'megan.ahearn@adops.com': {
          weight: 3,
        },
        'michael.edwards@adops.com': {
          weight: 0,
        },
        'michelle.signet@adops.com': {
          weight: 4,
        },
        'michelle.tom@adops.com': {
          weight: 3,
        },
        'misti.schindele@adops.com': {
          weight: 3,
        },
        'sara.steichen@adops.com': {
          weight: 4,
        },
        'travis.ayer@adops.com': {
          validate: true,
          weight: 5,
        },
      },
    },
    docs: {
      name: 'User Docs',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 9,
        },
        'cathleen.solario@adops.com': {
          weight: 4,
        },
        'chris.trammel@adops.com': {
          weight: 5,
        },
        'clara.russell@adops.com': {
          weight: 5,
        },
        'darcie.decaprio@adops.com': {
          weight: 3,
        },
        'heather.casterline@adops.com': {
          weight: 4,
        },
        'jen.hill@adops.com': {
          validate: true,
          weight: 4,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 4,
        },
        'maxwell.dickey@adops.com': {
          weight: 5,
        },
        'megan.ahearn@adops.com': {
          weight: 4,
        },
        'michael.edwards@adops.com': {
          weight: 0,
        },
        'michelle.signet@adops.com': {
          weight: 5,
        },
        'michelle.tom@adops.com': {
          weight: 4,
        },
        'misti.schindele@adops.com': {
          weight: 4,
        },
        'sara.steichen@adops.com': {
          weight: 5,
        },
        'travis.ayer@adops.com': {
          validate: true,
          weight: 6,
        },
      },
    },
    group: {
      name: 'Group',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 10,
        },
        'cathleen.solario@adops.com': {
          weight: 7,
        },
        'chris.trammel@adops.com': {
          weight: 7,
        },
        'clara.russell@adops.com': {
          weight: 4,
        },
        'darcie.decaprio@adops.com': {
          weight: 10,
        },
        'heather.casterline@adops.com': {
          weight: 6,
        },
        'jen.hill@adops.com': {
          validate: true,
          weight: 6,
        },
        'joanne.hurley@adops.com': {
          weight: 9,
        },
        'katie.obrien@adops.com': {
          weight: 8,
        },
        'maxwell.dickey@adops.com': {
          weight: 4,
        },
        'megan.ahearn@adops.com': {
          weight: 9,
        },
        'michael.edwards@adops.com': {
          weight: 10,
        },
        'michelle.signet@adops.com': {
          weight: 8,
        },
        'michelle.tom@adops.com': {
          weight: 5,
        },
        'misti.schindele@adops.com': {
          weight: 6,
        },
        'sara.steichen@adops.com': {
          weight: 8,
        },
        'travis.ayer@adops.com': {
          validate: true,
          weight: 3,
        },
      },
    },
    sort: {
      name: 'Sort',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 9,
        },
        'cathleen.solario@adops.com': {
          weight: 8,
        },
        'chris.trammel@adops.com': {
          weight: 9,
        },
        'clara.russell@adops.com': {
          weight: 7,
        },
        'darcie.decaprio@adops.com': {
          weight: 5,
        },
        'heather.casterline@adops.com': {
          weight: 5,
        },
        'jen.hill@adops.com': {
          validate: true,
          weight: 5,
        },
        'joanne.hurley@adops.com': {
          weight: 0,
        },
        'katie.obrien@adops.com': {
          weight: 10,
        },
        'maxwell.dickey@adops.com': {
          weight: 3,
        },
        'megan.ahearn@adops.com': {
          weight: 7,
        },
        'michael.edwards@adops.com': {
          weight: 10,
        },
        'michelle.signet@adops.com': {
          weight: 9,
        },
        'michelle.tom@adops.com': {
          weight: 8,
        },
        'misti.schindele@adops.com': {
          weight: 5,
        },
        'sara.steichen@adops.com': {
          weight: 9,
        },
        'travis.ayer@adops.com': {
          validate: true,
          weight: 2,
        },
      },
    },
  },
  proposed: {
    'adx-and-ob': {
      name: 'AdX and Open Bidding',
      data: ['programmatic'],
      features: ['data'],
      status: 'in progress',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 10,
        },
        'fairy.pardiwalla@adops.com': {
          weight: 80,
        },
        'jen.hill@adops.com': {
          weight: 80,
        },
        'katie.obrien@adops.com': {
          weight: 20,
        },
        'maxwell.dickey@adops.com': {
          weight: 80,
        },
        'travis.ayer@adops.com': {
          weight: 1,
        },
      },
    },
    'aggregated-programmatic-data-sources': {
      name: 'Aggregate SpringServe, Magnite, and Other Data Sources',
      data: ['programmatic'],
      features: ['data'],
      status: 'pending',
      votes: {
        'fairy.pardiwalla@adops.com': {
          weight: 1,
          comments: [
            {
              source: 'https://docs.google.com/document/d/1RWWlzeiJztVIJFgmd7vbfaDcvSmDhxh5dQBsmSa4nxI/edit#',
              text: 'Here’s what my prog revenue is and how my items are performing, because Google only has what you put in it. Yield and OB partners are different, but for others, Google can only say how many impressions it sent out, can’t say how much it actually served or the actual cpms or revenue was on those. Every DS is different, and ideally we have prog reporting that can aggregate these sources and aggregations and serve them in one place. That would be hugely valuable.',
            },
          ],
        },
      },
    },
    'revenue-to-date-by-demand-source': {
      name: 'Revenue to Date by Demand Source',
      data: ['programmatic'],
      features: ['data'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 6,
        },
        'travis.ayer@adops.com': {
          weight: 1,
        },
      },
    },
    'reseller-reports-ui': {
      name: 'Reseller Reports UI',
      data: ['organization', 'revenue'],
      features: ['data'],
      status: 'pending',
      votes: {
        'travis.ayer@adops.com': {
          weight: 1,
        },
      },
    },
    'faster-report-loads': {
      name: 'Faster Report Loads',
      data: [],
      features: ['maintenance'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
        'joanne.hurley@adops.com': {
          weight: 25,
        },
        'michelle.tom@adops.com': {
          weight: 10,
        },
      },
    },
    'faster-ticket-responses': {
      name: 'Faster Ticket Responses and Resolution Rates',
      data: [],
      features: ['maintenance'],
      status: 'pending',
      votes: {
        'joanne.hurley@adops.com': {
          weight: 50,
        },
      },
    },
    'liveintent-data': {
      name: 'LiveIntent as a Data Source',
      data: ['programmatic'],
      features: ['data'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
        'katie.obrien@adops.com': {
          weight: 1,
        },
      },
    },
    'magnate-data': {
      name: 'Magnate as a Data Source',
      data: ['programmatic'],
      features: ['data'],
      status: 'pending',
      votes: {
        'fairy.pardiwalla@adops.com': {
          weight: 1,
        },
      },
    },
    'springserve-data': {
      name: 'SpringServe as a Data Source',
      data: ['programmatic'],
      features: ['data'],
      status: 'pending',
      votes: {
        'fairy.pardiwalla@adops.com': {
          weight: 1,
        },
      },
    },
    'bulk-edit-ui': {
      name: 'Bulk Edit UI',
      data: ['pacing'],
      features: ['bulk-edit'],
      status: 'pending',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 70,
        },
        'chris.trammel@adops.com': {
          weight: 80,
        },
        'darcie.decaprio@adops.com': {
          weight: 7,
        },
        'joanne.hurley@adops.com': {
          weight: 25,
        },
        'katie.obrien@adops.com': {
          weight: 40,
        },
        'michelle.signet@adops.com': {
          weight: 80,
        },
        'michelle.tom@adops.com': {
          validate: true,
          weight: 40,
        },
        'sara.steichen@adops.com': {
          weight: 80,
        },
      },
    },
    'timesheet-changelog': {
      name: 'Time(sheet) Change Log',
      data: ['time'],
      features: ['change-log'],
      status: 'pending',
      description: 'Track changes to time(sheet) entries.',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 10,
        },
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
      },
    },
    'multi-network-pacing': {
      name: 'Multi-Network Pacing Views',
      data: ['pacing'],
      features: ['data'],
      status: 'pending',
      votes: {
        'clara.russell@adops.com': {
          weight: 80,
        },
        'katie.obrien@adops.com': {
          weight: 2,
        },
      },
    },
    'org-org-relationships': {
      name: 'Organization Associations',
      data: ['organization'],
      features: ['data'],
      status: 'pending',
    },
    'org-person-relationships': {
      name: 'Org-Person Relationships',
      data: ['organization', 'person'],
      features: ['data'],
      status: 'pending',
      description: 'Alongside the person-person relationships, this would address the Christmas card issue.',
    },
    'org-project-relationships': {
      name: 'Org-Project Relationships',
      data: ['organization', 'project'],
      features: ['data'],
      status: 'pending',
    },
    'person-person-relationships': {
      name: 'Person-Person Relationships',
      data: ['person'],
      features: ['data'],
      description: 'Alongside the org-person relationships, this would address the Christmas card issue.',
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 2,
        },
      },
    },
    'enhanced-person-profiles': {
      name: 'Enhanced User Profiles',
      data: ['person'],
      features: ['data'],
      status: 'pending',
      description: 'Expose more person data, including org associations, roles, and addresses.',
    },
    'user-record-management': {
      name: 'Improve User Record Management',
      data: ['person'],
      features: ['data'],
      status: 'in progress',
      description: 'Empower users to manage the appropriate user records quickly and easily from the UI.',
    },
    'demo-mode': {
      name: 'Demo Mode',
      data: ['demo'],
      features: ['demo-mode'],
      status: 'ready',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 5,
        },
        'michael.edwards@adops.com': {
          weight: 20,
        },
        'travis.ayer@adops.com': {
          validate: true,
          weight: 10,
        },
      },
    },
    'internal-revenue-reports': {
      name: 'Internal Revenue Reports',
      data: ['revenue'],
      features: ['data'],
      status: 'pending',
      votes: {
        'fairy.pardiwalla@adops.com': {
          weight: 80,
          comments: [
            {
              source: 'https://docs.google.com/document/d/1RWWlzeiJztVIJFgmd7vbfaDcvSmDhxh5dQBsmSa4nxI/edit#',
              text: 'a client has project with us, and we let them know when they’re starting to exceed the number of hours they’ve budgeted for our work. It would be  different for every client, but it’s generally based on billable hours.',
            },
          ],
        },
        'michael.edwards@adops.com': {
          weight: 80,
        },
        'travis.ayer@adops.com': {
          weight: 1,
        },
      },
    },
    'external-revenue-reports': {
      name: 'External-Facing Revenue Reports',
      data: ['revenue'],
      features: ['data'],
      status: 'pending',
      votes: {
        'travis.ayer@adops.com': {
          weight: 1,
        },
      },
    },
    'business-rules-endpoint': {
      name: 'Business Rules Endpoint',
      data: ['organization'],
      features: ['data'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0,
        },
      },
    },
    'expose-vast-info': {
      name: 'Expose VAST Info',
      data: ['pacing'],
      features: ['data'],
      status: 'pending',
      votes: {
        'cathleen.solario@adops.com': {
          weight: 80,
          comments: [
            {
              source: 'https://docs.google.com/document/d/1lT2d0pjZOfKiOBVIH0V8NiQcls29OZZd2FJn6rDChPQ/edit#',
              text: 'For NFL we often have to track down video line items that have VAST and/or VPAID type video assigned. If this topic/feature would “reveal” this information in iAdops it would be a time saver. Various reasons for the need to track down this information can be the following (client inquiry, targeting updates which require one or the other type of video lines to be adjusted, Ad Products Team needing an example for testing purposes, etc... )',
            },
          ],
        },
        'megan.ahearn@adops.com': {
          weight: 80,
        },
      },
    },
    'master-account-spreadsheet': {
      name: 'Org Pages Replace Master Account Info Spreadsheet',
      description: 'Organization pages replace the master account info spreadsheet.',
      data: ['organization'],
      features: ['data'],
      href: [
        {
          text: 'Master Account Info',
          href: 'https://docs.google.com/spreadsheets/d/1SnY-OQaarMIhYV6_IaUr7J2Lg3s10_TNbwvx9SJhnKw/edit#gid=1295665923',
          target: '_blank',
        },
      ],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 4,
        },
        'katie.obrien@adops.com': {
          weight: 10,
        },
        'travis.ayer@adops.com': {
          weight: 80,
        },
      },
    },
    'internal-data-changelog': {
      name: 'Internal Data Change Log',
      data: ['organization', 'person', 'project', 'time'],
      features: ['change-log'],
      description: 'Track changes to internal data.',
      status: 'pending',
    },
    'client-revenue-indicators': {
      name: 'Client Revenue Indicators',
      data: ['organization'],
      features: ['data'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
        'travis.ayer@adops.com': {
          weight: 1,
        },
      },
    },
    'master-companion-creatives': {
      name: 'Master/Companion Creatives',
      description: 'Expose master/companion creatives data in Pacing.',
      data: ['pacing'],
      features: ['data'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 5,
        },
        'heather.casterline@adops.com': {
          weight: 80,
        },
      },
    },
    'freewheel-reports': {
      name: 'Freewheel Reports',
      data: [],
      features: ['data'],
      status: 'pending',
      votes: {
        'katie.obrien@adops.com': {
          weight: 1,
        },
        'misti.schindele@adops.com': {
          weight: 90,
        },
      },
    },
    'user-aliasing': {
      name: 'User Aliasing',
      data: ['person'],
      features: ['maintenance'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 5,
        },
      },
    },
    'org-vendor-data': {
      name: 'Represent Vendors as Organizations',
      description: 'Add vendors to our list of organizations.',
      data: ['organization'],
      features: ['data'],
      status: 'pending',
      votes: {
        'travis.ayer@adops.com': {
          weight: 1,
        },
      },
    },
    'org-service-data': {
      name: 'Represent Organization\'s Services',
      description: 'Show services in organization pages.',
      data: ['organization'],
      features: ['data'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 4,
        },
        'travis.ayer@adops.com': {
          weight: 60,
        },
      },
    },
    'app-security': {
      name: 'Application Security',
      data: [],
      features: ['maintenance'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
      },
    },
    'user-facing-prefilter-forms': {
      name: 'User-Facing Prefilter Forms',
      description: 'Define a custom set of filters applied at page load.',
      data: ['pacing'],
      features: ['filters'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 5,
        },
        'michelle.tom@adops.com': {
          validate: true,
          weight: 30,
        },
      },
    },
    'quick-reports': {
      name: 'Quick Reports',
      data: ['pacing'],
      features: ['data'],
      status: 'pending',
      votes: {
        'misti.schindele@adops.com': {
          weight: 10,
        },
      },
    },
    'alert-missing-time': {
      name: 'Alert for Missing Time',
      description: 'Remind managers and other internals of missing time entries for the previous week.',
      data: ['time'],
      features: ['alerts'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
        'katie.obrien@adops.com': {
          weight: 1,
        },
      },
    },
    'data-refresh-by-client-timezone': {
      name: 'Optimize Data Refresh by Network Timezone',
      description: 'Optimize the data refresh by the timezone set on the network, as well as the timezones associated with the clients\' users.',
      data: ['discrepancy', 'pacing', 'programmatic'],
      features: ['data-freshness'],
      status: 'pending',
      votes: {
        'michelle.tom@adops.com': {
          weight: 20,
        },
      },
    },
    'historical-custom-data-range': {
      name: 'Custom Date Range for Historical Reporting',
      description: 'Expand the default 10-day window for historical reporting using a custom date range the user defines.',
      data: ['pacing'],
      features: ['data', 'filters'],
      status: 'pending',
    },
    'user-analytics': {
      name: 'User Analytics',
      data: ['user-analytics'],
      features: ['maintenance'],
      status: 'in progress',
      votes: {
        'travis.ayer@adops.com': {
          weight: 40,
        },
        'katie.obrien@adops.com': {
          weight: 5,
        },
      },
    },
    'share-and-save-urls': {
      name: 'Share and Save URLs',
      data: [],
      features: ['filters'],
      status: 'in progress',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
      },
    },
    'stability-enhancements': {
      name: 'Stability Enhancements',
      data: [],
      features: ['maintenance'],
      status: 'in progress',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
      },
    },
    'published-backlog': {
      name: 'Published Backlog',
      data: [],
      features: ['maintenance'],
      status: 'in progress',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
      },
    },
    'non-impression-units': {
      name: 'Represent Non-Impression Units',
      data: ['pacing'],
      features: ['data'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
      },
    },
    'active-line-items-report': {
      name: 'Active Line Items Report',
      data: ['pacing'],
      features: ['data'],
      status: 'pending',
      votes: {
        'clara.russell@adops.com': {
          weight: 20,
        },
        'darcie.decaprio@adops.com': {
          weight: 2,
        },
        'heather.casterline@adops.com': {
          weight: 20,
        },
      },
    },
    'external-facing-api': {
      name: 'External-Facing API Documentation',
      data: [],
      features: ['data'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 1,
        },
      },
    },
    'revenue-at-risk': {
      name: 'Add Revenue-at-Risk as Saved Filter',
      data: ['pacing', 'revenue'],
      features: ['data'],
      status: 'in progress',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 8,
        },
        'katie.obrien@adops.com': {
          weight: 10,
        },
        'megan.ahearn@adops.com': {
          weight: 12,
        },
        'michelle.signet@adops.com': {
          weight: 12,
        },
        'sara.steichen@adops.com': {
          weight: 12,
        },
      },
    },
    'export-as-xlsx': {
      name: 'Export as XLSX',
      data: [],
      features: ['export'],
      status: 'in progress',
      votes: {
        'cathleen.solario@adops.com': {
          weight: 12,
        },
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
        'katie.obrien@adops.com': {
          weight: 1,
        },
        'megan.ahearn@adops.com': {
          weight: 9,
        },
      },
    },
    'export-as-pdf': {
      name: 'Export as PDF',
      data: [],
      features: ['export'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
        'katie.obrien@adops.com': {
          weight: 1,
        },
      },
    },
    'accessible-themes': {
      name: 'Accessible Themes',
      description: 'Empower accessibility through contextual themes.',
      data: [],
      features: ['maintenance'],
      status: 'pending',
    },
    'onboarding-screencasts': {
      name: 'Onboarding Screencasts',
      data: [],
      features: ['maintenance'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
      },
    },
    'omnisearch-show-all-networks': {
      name: 'Omnisearch: Show All Networks',
      data: [],
      features: ['omnisearch'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 2,
        },
      },
    },
    'multiple-date-ranges': {
      name: 'Input Multiple Date Ranges',
      description: 'Allow users to enter multiple date ranges into date input fields.',
      data: [],
      features: ['filters'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 2,
        },
      },
    },
    'status-page': {
      name: 'Restore Status Page',
      description: 'Report the application\'s availability.',
      data: [],
      features: ['maintenance'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
        'maxwell.dickey@adops.com': {
          weight: 12,
        },
      },
    },
    'user-docs': {
      name: 'Extend User Docs',
      description: 'Update and extend the user docs to represent the latest state.',
      data: [],
      features: ['maintenance'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 2,
        },
      },
    },
    'column-freezing': {
      name: 'Freeze Columns',
      description: 'Users should be able to freeze multiple columns to aid horizontal scanning.',
      data: [],
      features: ['column-and-row-tools'],
      status: 'pending',
      votes: {
        'chris.trammel@adops.com': {
          weight: 8,
        },
        'darcie.decaprio@adops.com': {
          weight: 2,
        },
        'katie.obrien@adops.com': {
          weight: 1,
        },
        'sara.steichen@adops.com': {
          weight: 8,
        },
      },
    },
    'discrepancy-party-analysis': {
      name: 'Empower 1st and 3rd Party Analysis in Discrepancy',
      description: 'Add columns to Discrepancy aimed at 1st and 3rd party analysis.',
      data: ['discrepancy'],
      features: ['data'],
      status: 'pending',
      votes: {
        'cathleen.solario@adops.com': {
          weight: 8,
        },
        'darcie.decaprio@adops.com': {
          weight: 2,
        },
        'maxwell.dickey@adops.com': {
          weight: 8,
        },
      },
    },
    'discrepancy-saved-filters': {
      name: 'Discrepancy Saved Filters',
      description: 'Add saved filters to Discrepancy a la Pacing.',
      data: ['discrepancy'],
      features: ['filters'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 4,
        },
      },
    },
    'recent-search-results': {
      name: 'Recent Search Results',
      description: 'List recent search results on focus of the omnisearch input.',
      data: [],
      features: ['omnisearch'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 1,
        },
      },
    },
    'get-all-tearsheets': {
      name: 'Get All Tearsheets',
      data: ['pacing'],
      features: ['tearsheets'],
      status: 'pending',
      votes: {
        'katie.obrien@adops.com': {
          weight: 1,
        },
      },
    },
    'pacing-group-level-totals': {
      name: 'Pacing Group-Level Totals',
      data: ['pacing'],
      features: ['data'],
      status: 'in progress',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 3,
        },
        'katie.obrien@adops.com': {
          weight: 1,
        },
      },
    },
    'select-all-dropdown-options': {
      name: 'Select All Dropdown Options',
      description: 'Select all dropdown options in a filter form input with one click.',
      data: [],
      features: ['filters'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 2,
        },
        'michelle.signet@adops.com': {
          weight: 4,
        },
      },
    },
    'omnisearch-flex-width': {
      name: 'Flex the Width of the OmniSearch on Focus',
      data: [],
      features: ['omnisearch'],
      status: 'pending',
    },
    'duration-consume-as-you-type': {
      name: 'Timesheet Duration Input: Consume As You Type',
      data: ['time'],
      features: ['timesheets'],
      status: 'pending',
      votes: {
        'chris.trammel@adops.com': {
          weight: 4,
        },
        'michelle.signet@adops.com': {
          weight: 4,
        },
      },
    },
    'tooltips-on-nav': {
      name: 'Tooltips on Hover of Collapsed Sidebar Items',
      description: 'Show tooltips on hover of a navigation item when the drawer is collapsed.',
      data: [],
      features: ['navigation'],
      status: 'pending',
      votes: {
        'chris.trammel@adops.com': {
          weight: 4,
        },
      },
    },
    'highlight-selected-line-items': {
      name: 'Highlight Selected Line Item',
      description: 'Highlight a line item on click of the line item\'s options, e.g. Historical Report, indicating to the user which line item is currently detailed, even if they scroll.',
      data: ['pacing'],
      features: ['column-and-row-tools'],
      status: 'pending',
      votes: {
        'chris.trammel@adops.com': {
          weight: 4,
        },
      },
    },
    'internal-data-maintenance': {
      name: 'Internal Data Maintenance',
      description: 'Assure internal data is up to date and consistently maintained',
      data: ['organization', 'person', 'project'],
      features: ['data'],
      status: 'pending',
      votes: {
        'katie.obrien@adops.com': {
          weight: 2,
        },
      },
    },
    'hours-by-project': {
      name: 'Summarize Hours by Project',
      description: 'Surface hours by project on the Time, Time Rollup, and Project pages',
      data: ['project', 'time'],
      features: ['timesheets'],
      status: 'pending',
      votes: {
        'michael.edwards@adops.com': {
          weight: 2,
        },
      },
    },
    'data-refresh-doc-updates': {
      name: 'Update Data Refresh Doc',
      description: 'Assure the documentation around our data refresh remains up to date.',
      data: [],
      features: ['data-freshness'],
      status: 'pending',
      votes: {
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
      },
    },
    'expose-saved-filters-in-person-pages': {
      name: 'Expose Saved Filters in Person Pages',
      data: ['person'],
      features: ['filters'],
      status: 'pending',
    },
    'adx-and-adx-pg-time-summaries': {
      name: 'AdX and AdX-PG Time Summaries',
      data: ['time'],
      features: ['timesheets'],
      status: 'pending',
      votes: {
        'carol.coroniti@adops.com': {
          weight: 20,
        },
        'darcie.decaprio@adops.com': {
          weight: 0.5,
        },
      },
    },
  },
}

export default backlog
